import { reactive } from 'vue';
import { AppService } from './app.machine';

export interface Store {
  // FIXME: XState v5 should fix these types
  appService: AppService | undefined;
}

export const store: Store = reactive({
  appService: undefined,
});
